export const fr = {
  slogan: 'Évolue. Domine. Recommence.',
  playGuest: 'Jouer en invité',
  namePlaceholder: 'Ton nom de tank',
  connecting: 'Connexion au serveur…',
  disconnected: 'Connexion perdue. Nouvelle tentative…',
  serverVersion: 'Version du jeu obsolète : recharge la page.',
  modeFfa: 'Arène libre (FFA)',
  modeFfaDesc: 'Tous contre tous, bots identifiés en complément.',
  classTree: 'Arbre des classes',
  settings: 'Paramètres',
  help: 'Aide',
  close: 'Fermer',
  back: 'Retour',
  language: 'Langue',
  level: 'Niveau {n}',
  score: 'Score',
  rank: 'Rang {r}/{n}',
  leaderboard: 'Classement',
  arenaPop: '{h} humains · {b} bots',
  bot: 'BOT',
  statPoints: '{n} point(s) à placer',
  stat_maxHealth: 'Vie maximale',
  stat_regen: 'Régénération',
  stat_bodyDamage: 'Dégâts corporels',
  stat_moveSpeed: 'Vitesse',
  stat_bulletDamage: 'Dégâts projectiles',
  stat_penetration: 'Pénétration',
  stat_bulletSpeed: 'Vitesse projectiles',
  stat_reload: 'Cadence',
  evolveTitle: 'Évolution disponible',
  evolveLater: 'Plus tard',
  evolveNext: 'Prochaine évolution au niveau {n}',
  evolveMax: 'Évolution terminée',
  planned: 'prévue',
  implemented: 'jouable',
  protected: 'Protection {s} s — tirer l’annule',
  bonusActive: 'Bonus de reprise ×2 : {s} s · {xp} XP restants',
  heat: 'Chauffe',
  charge: 'Charge',
  deadTitle: 'Tank détruit',
  deadBy: 'Détruit par {name}',
  deadByEnv: 'Détruit par l’environnement',
  deadScore: 'Score de la vie : {n}',
  deadLevel: 'Niveau atteint : {n}',
  deadTime: 'Temps de vie : {n}',
  deadKills: 'Éliminations : {n}',
  respawnFree: 'Repartir en petit tank',
  respawnBonus: 'Bonus de reprise : ×2 XP pendant {s} s (plafonné à 20 % de l’XP perdue).',
  respawnNoBonus: 'Pas de bonus de reprise sous le niveau 10.',
  killed: 'Tu as éliminé {name} (+{xp} XP)',
  levelUp: 'Niveau {n} !',
  evolved: 'Nouvelle classe : {name}',
  bonusEnded: 'Bonus de reprise terminé',
  settingsAudio: 'Volume',
  settingsParticles: 'Particules',
  settingsLow: 'Faibles',
  settingsMedium: 'Moyennes',
  settingsHigh: 'Élevées',
  settingsShake: 'Secousses d’écran',
  settingsReducedMotion: 'Animations réduites',
  settingsAutofire: 'Tir automatique au démarrage',
  settingsJoyOpacity: 'Opacité des joysticks',
  settingsJoySensitivity: 'Sensibilité visée tactile',
  settingsDeadzone: 'Zone morte des joysticks',
  settingsJoyFixed: 'Joysticks à position fixe',
  settingsQuality: 'Résolution interne',
  on: 'Activé',
  off: 'Désactivé',
  autofireOn: 'Tir auto : activé (E)',
  autofireOff: 'Tir auto : désactivé (E)',
  autofire: 'Tir auto',
  stats: 'Stats',
  landscapeHint: 'Tourne ton téléphone en paysage pour mieux jouer.',
  helpPc: 'PC : WASD / ZQSD ou flèches pour bouger, souris pour viser, clic maintenu pour tirer, E pour le tir automatique, 1–8 pour les statistiques.',
  helpMobile: 'Mobile : joystick gauche pour bouger, joystick droit pour viser et tirer (au-delà de la zone morte).',
  helpBots: 'Les bots sont toujours signalés par un badge BOT. Il n’y a jamais de faux joueurs.',
  helpFairView: 'Le champ de vision est le même sur tous les écrans.',
  treeIntro: 'Les 150 nœuds de classes du catalogue.',
  treeFamily: 'Famille',
  wip: 'Version de développement — progression non sauvegardée (invité).',
  ping: 'Ping {n} ms',
  fps: '{n} FPS',
  rotationWarn: 'Changement de carte dans {s} s',
  rotationDone: 'Nouvelle carte : {map}',
  rotationIn: 'Carte suivante dans {t}',
  rotationPending: 'Rotation après le boss',
  bossSpawn: 'Boss apparu en zone violette : {name}',
  bossDown: 'Boss vaincu ! Podium : {names}',
  bossRetreat: 'Le boss bat en retraite (5 min écoulées) — aucune récompense',
  bossIn: 'Boss dans {t}',
  bossAlive: '{name} · {hp} % · {t}',
  boss_bastion: 'Bastion colossal',
  boss_faucheur: 'Faucheur colossal',
  boss_sentinelle: 'Sentinelle colossale',
  boss_chimere: 'Chimère',
  map_A: 'Archipel',
  map_B: 'Spirale',
  map_C: 'Bipôle',
  zoneLegend: 'Zones : gris = formes · I vert · II orange · III rouge · BOSS violet',
  slot_weapon: 'Modification d’arme',
  slot_chassis: 'Modification de châssis',
  slot_passive: 'Passif',
  modTeamOnly: 'Effet en modes équipes uniquement',
  modEquipped: 'Modification : {name}',
  locked: 'Un missile vous a verrouillé !',
  shield: 'Bouclier',
  telemetry: 'Distance : {n}',
  info_rearAlert: 'Projectile derrière vous',
  treeMods: 'Modifications (300)',
  treeClasses: 'Classes (150)',
  modCompat: 'Compatible : {list}',
  modAny: 'toutes les classes',
  rewardCoins: '{n} pièces',
  rewardGems: '{n} gemmes',
  token_tok_x2: 'Jeton ×2',
  token_tok_x5: 'Jeton ×5',
  token_tok_restore: 'Jeton restauration',
  token_tok_reset: 'Jeton réinitialisation',
  token_tok_salon: 'Jeton salon',
  account: 'Compte',
  loading: 'Chargement…',
  tab_profile: 'Profil',
  tab_pass: 'Pass',
  tab_friends: 'Amis',
  forgotSent: 'Si un compte existe pour cette adresse, un e-mail vient d’être envoyé.',
  registered: 'Compte créé. Vérifie ton e-mail pour encaisser la roulette et acheter.',
  rateLimited: 'Trop de tentatives, réessaie dans une minute.',
  badCredentials: 'E-mail ou mot de passe incorrect.',
  err_email: 'Adresse e-mail invalide.',
  err_password: 'Mot de passe : 10 caractères minimum.',
  err_name: 'Nom affiché invalide (3 à 16 caractères, pas de nom réservé).',
  err_server: 'Erreur du serveur, réessaie.',
  guestInfo: 'Tu joues en invité ({n} pièces provisoires). Crée un compte ou connecte-toi pour les conserver : elles seront transférées une seule fois.',
  email: 'E-mail',
  password: 'Mot de passe',
  displayName: 'Nom affiché',
  login: 'Se connecter',
  register: 'Créer un compte',
  sendReset: 'Envoyer le lien',
  forgot: 'Mot de passe oublié',
  oauthSoon: 'Connexion Google et Discord : disponible quand l’adresse publique du jeu sera configurée.',
  verified: 'e-mail vérifié',
  notVerified: 'e-mail non vérifié',
  sent: 'Envoyé',
  resend: 'Renvoyer',
  dailyMissions: 'Missions du jour (+{c} pièces, +{x} XP de pass chacune)',
  weeklyMissions: 'Missions de la semaine (+{c} pièces, +{x} XP de pass chacune)',
  rouletteWeek: 'Roulette cette semaine : {n} / {max} (remise à zéro lundi 00:00 UTC).',
  logout: 'Se déconnecter',
  passEnds: 'fin le {d}',
  buyPremium: 'Pass premium — 900 gemmes',
  premiumInfo: 'Achat unique pour la saison, sans renouvellement. Les récompenses premium déjà atteintes sont données une fois.',
  premium_ok: 'Pass premium activé.',
  premium_already: 'Tu as déjà le pass premium.',
  premium_funds: 'Pas assez de gemmes.',
  premium_verify: 'Vérifie ton e-mail avant tout achat.',
  premium_server: 'Erreur du serveur.',
  addFriend: 'Ajouter',
  noFriends: 'Aucun ami pour l’instant. Partage ton identifiant public (TS-…).',
  online: 'en ligne',
  offline: 'hors ligne',
  fstatus_friend: 'ami',
  fstatus_outgoing: 'demande envoyée',
  fstatus_incoming: 'demande reçue',
  accept: 'Accepter',
  remove: 'Retirer',
  block: 'Bloquer',
  friend_sent: 'Demande envoyée.',
  friend_accepted: 'Vous êtes maintenant amis.',
  friend_blocked: 'Impossible : blocage actif.',
  friend_self: 'C’est ton propre identifiant.',
  friend_exists: 'Déjà ami ou demande en cours.',
  friend_unknown: 'Identifiant introuvable.',
  devMailbox: 'Boîte e-mail de test (développement)',
  devMailboxOff: 'Indisponible (production).',
  roulette: 'Roulette de fin de run',
  rLevel: 'Niveau {n}',
  rActive: 'Temps actif : {a} / {b}',
  rRaw: 'XP brute : {a} / {b}',
  rFeats: '3 éliminations ({k}) ou 30 monstres ({m})',
  rWeek: 'Encaissements cette semaine : {n} / 3',
  rNeedAccount: 'Compte requis pour encaisser.',
  rNeedVerify: 'E-mail vérifié requis pour encaisser.',
  rConfirm: 'Encaisser termine ton tank et ce run. Les restaurations ne seront plus possibles. Le résultat est tiré par le serveur.',
  rCashout: 'Encaisser',
  cancel: 'Annuler',
  rResCoins: '{n} pièces',
  rResPass: '+{n} niveaux de pass (converti : {c} pièces)',
  rResSingularity: 'Cosmétique exceptionnel « Singularité » ({v}) !',
  rOdds: 'Probabilités : 5000 pièces 50 % · 5 jetons 35 % · 5 niveaux de pass 14,999 % · Singularité 0,001 %.',
  cashoutErr_unavailable: 'Encaissement indisponible.',
  cashoutErr_account: 'Compte requis pour encaisser.',
  cashoutErr_verify: 'Vérifie ton e-mail pour encaisser.',
  cashoutErr_eligibility: 'Conditions de la roulette non remplies.',
  cashoutErr_combat: 'Sors du combat 10 secondes avant d’encaisser.',
  cashoutErr_zone: 'Impossible dans la zone du boss.',
  cashoutErr_cap: 'Limite de 3 encaissements atteinte cette semaine.',
  cashoutErr_error: 'Erreur du serveur : rien n’a été débité ni tiré.',
  cashedTitle: 'Run encaissé',
  guestChip: 'Invité — se connecter',
  verifyOk: 'Adresse e-mail vérifiée.',
  verifyFail: 'Lien de vérification invalide ou expiré.',
  resetOk: 'Mot de passe modifié : reconnecte-toi.',
  resetFail: 'Lien de réinitialisation invalide ou expiré.',
  resetTitle: 'Nouveau mot de passe',
  boostActive: 'Boost {k} : {s} s',
  boostEnded: 'Boost terminé',
  chfInfo: 'Prix finaux en CHF. Les gemmes ne sont ni retirables, ni échangeables, ni revendables.',
  confirm: 'Confirmer',
  convert: 'Convertir',
  convertTitle: 'Conversion gemmes → pièces (sens unique)',
  equip: 'Équiper',
  gemPacks: 'Gemmes',
  inventoryTitle: 'Mes apparences',
  orderCancelled: 'Paiement annulé : rien n’a été débité.',
  orderChecking: 'Vérification du paiement auprès du serveur…',
  orderFailed: 'Paiement échoué : aucune gemme créditée.',
  orderPaid: 'Paiement confirmé : {n} gemmes créditées.',
  orderPending: 'Paiement encore en attente de confirmation. Les gemmes arriveront dès réception de la confirmation.',
  owned: 'Possédé',
  paySimulator: 'MODE DÉVELOPPEMENT — simulateur de paiement fictif : aucun argent réel, aucune carte.',
  payStripeTest: 'Stripe en mode test : utilise les cartes de test Stripe, aucun argent réel.',
  payStripeLive: 'Paiements réels activés.',
  resetBtn: 'Réinitialiser ({n})',
  resetConfirm: 'Garder l’XP, rembourser points et modifications, revenir à la classe de base ? Hors combat 8 s, une fois par vie, 15 min entre deux.',
  restoreBtn: 'Restaurer ma progression (jetons : {n}, restaurations : {r})',
  shopVerify: 'Vérifie ton e-mail pour acheter.',
  tokensInfo: 'Les jetons donnent un avantage dans les modes qui les autorisent (FFA) ; ils ne sont pas purement cosmétiques.',
  tokensTitle: 'Jetons',
  weeklyShop: 'Boutique de la semaine (prochaine rotation : {d})',
  shop_ok: 'Achat effectué.',
  shop_owned: 'Déjà possédé.',
  shop_funds: 'Solde insuffisant.',
  shop_unavailable: 'Offre indisponible cette semaine.',
  shop_frozen: 'Dépenses gelées : un remboursement est en cours de revue.',
  shop_verify: 'Vérifie ton e-mail pour acheter.',
  shop_invalid: 'Demande invalide.',
  shop_closed: 'Les achats de gemmes ne sont pas encore ouverts.',
  ckind_skin: 'Apparence',
  ckind_collection: 'Collection multi-classes',
  ckind_emblem: 'Emblème',
  ckind_trail: 'Traînée',
  ckind_killfx: 'Effet d’élimination',
  ckind_deathfx: 'Effet de destruction',
  ckind_banner: 'Bannière',
  ckind_frame: 'Cadre',
  base_atelier: 'Atelier (acier)',
  base_desert: 'Désert (sable)',
  base_boreal: 'Boréal (bleu)',
  base_obsidienne: 'Obsidienne (noir)',
  base_signal: 'Signal (orange)',
  tokenOk_tok_x2: 'Boost ×2 activé (90 s)',
  tokenOk_tok_x5: 'Boost ×5 activé (60 s, éliminations de tanks)',
  tokenOk_tok_restore: 'Progression restaurée',
  tokenOk_tok_reset: 'Build réinitialisé : choisis une nouvelle branche',
  tokenErr_unavailable: 'Jeton indisponible ici.',
  tokenErr_active: 'Un boost est déjà actif ({s} s restantes) : jeton non consommé.',
  tokenErr_bonus: 'Le bonus de reprise est actif ({s} s) : jeton non consommé.',
  tokenErr_limit: 'Limite atteinte : jeton non consommé.',
  tokenErr_expired: 'Délai de restauration dépassé.',
  tokenErr_combat: 'Sors du combat 8 secondes d’abord.',
  tokenErr_zone: 'Impossible dans la zone du boss.',
  tokenErr_none: 'Tu n’as pas ce jeton.',
  tokenErr_cooldown: 'Réinitialisation en recharge (15 min par compte).',
  tokenErr_error: 'Erreur du serveur : jeton non consommé.',
  tokenErr_state: 'La situation a changé : jeton restitué.',
  tab_shop: 'Boutique',
  botsInMatch: '{n} bot(s) annoncé(s) dans ce match',
  closeLobby: 'Fermer le salon',
  defeat: 'Défaite',
  draw: 'Match nul',
  kick: 'Expulser',
  lobbyCode: 'Salon',
  lobbyExpires: 'Fin du salon : {d}',
  lock: 'Verrouiller',
  unlock: 'Déverrouiller',
  makeHost: 'Donner l’hôte',
  map_T: 'Terrain neutre',
  noRewards: 'Partie personnalisée — aucune récompense',
  overtime: 'Prolongation {t}',
  prepIn: 'Préparation : {s} s',
  privBoss: 'Boss',
  privBots: 'Bots',
  privCode: 'Code du salon (6 caractères)',
  privCreate: 'Créer un salon',
  privInfo: 'Pass premium actif ou un jeton salon (consommé seulement à l’ouverture réussie), 4 h, un salon actif par compte. Aucune récompense.',
  privJoin: 'Rejoindre',
  privMap: 'Carte',
  privMax: 'Joueurs max',
  privMonsters: 'Monstres',
  privTeams: 'Équipes',
  privXp: 'Multiplicateur d’XP',
  quickTitle: 'Messages rapides (F1–F6)',
  teamRewardInfo: 'Récompenses : 100 pièces de participation complète + 50 en cas de victoire, au prorata du temps joué.',
  victory: 'Victoire !',
  waitingPlayers: 'En attente de joueurs — bots annoncés dans {s} s',
  waveOf: 'Vague {n} / {max}',
  teamRespawn: 'Réapparition avec 75 % de ton XP : niveau, classe et points recalculés (points à réattribuer).',
  survivalSpectate: 'Spectateur jusqu’à la prochaine vague réussie, puis retour avec 75 % de ton XP.',
  mode_ffa: 'Arène libre',
  mode_tdm: 'Match à mort',
  mode_dom: 'Domination',
  mode_survival: 'Survie',
  mode_private: 'Partie privée',
  modeDesc_ffa: 'Tous contre tous, bots identifiés en complément, cartes tournantes, boss.',
  modeDesc_tdm: 'Deux équipes, 10 minutes ou 30/60/100 éliminations. À la mort, tu gardes 75 % de ton XP.',
  modeDesc_dom: 'Trois points à capturer (8 s de présence incontestée), 1 point par seconde de contrôle, 1000 ou 12 minutes.',
  modeDesc_survival: 'Coopération 1 à 6 joueurs, 30 vagues, boss toutes les 5 vagues.',
  modeDesc_private: 'Règles personnalisées, sans aucune récompense.',
  diff_facile: 'Facile',
  diff_normal: 'Normal',
  diff_moyen: 'Moyen',
  diff_difficile: 'Difficile',
  diff_ultra: 'Ultra difficile',
  diff_tankshift: 'TANKSHIFT',
  quick_gg: 'Bien joué',
  quick_warning: 'Attention',
  quick_joinMe: 'Rejoins-moi',
  quick_thanks: 'Merci',
  quick_help: 'À l’aide',
  quick_retreat: 'Repli',
  leave_ended: 'Le match est terminé.',
  leave_kicked: 'Tu as été expulsé du salon.',
  leave_lobby_auth: 'Connecte-toi pour créer un salon.',
  leave_lobby_one: 'Tu as déjà un salon actif.',
  leave_lobby_token: 'Il faut le pass premium actif ou un jeton salon.',
  leave_lobby_error: 'Erreur lors de l’ouverture du salon : aucun jeton consommé.',
  leave_lobby_missing: 'Salon introuvable, verrouillé ou plein.',
  matchStartsIn: 'Début de la manche dans {s} s',
  group: 'Groupe',
  groupLeave: 'Quitter',
  decline: 'Refuser',
  groupInvitedBy: '{name} t’invite dans son groupe ({n})',
  groupPromote: 'Nommer chef',
  groupPending: 'invitation envoyée',
  groupEmpty: 'Invite des amis pour jouer ensemble : même match et même équipe (4 max en arène libre où vous restez adversaires, 6 en survie, la taille d’une équipe en match).',
  groupPlaceholder: 'Message au groupe',
  groupSend: 'Envoyer',
  groupReport: 'Signaler ou bloquer',
  groupJoinLaunch: 'Rejoindre le groupe',
  groupTooBig: 'Ton groupe compte {n} joueurs : ce mode en accepte {max} au plus.',
  groupLeaderPlays: 'Le chef du groupe lance la partie pour tout le groupe.',
  blockedDone: '{name} est bloqué : ses messages sont masqués.',
  queuePlayers: '{n} en jeu',
  ginv_sent: 'Invitation envoyée.',
  ginv_self: 'Tu ne peux pas t’inviter toi-même.',
  ginv_not_friend: 'Seuls tes amis peuvent être invités.',
  ginv_blocked: 'Invitation impossible (blocage).',
  ginv_full: 'Groupe complet (8 au maximum).',
  ginv_already: 'Déjà dans le groupe.',
  ginv_not_leader: 'Seul le chef peut inviter.',
  ginv_unknown: 'Joueur introuvable.',
  gacc_ok: 'Tu as rejoint le groupe.',
  gacc_expired: 'Invitation expirée.',
  gacc_full: 'Groupe complet.',
  gacc_blocked: 'Impossible : un membre du groupe est bloqué.',
  chat_rate: 'Trop de messages : attends un peu.',
  chat_dup: 'Message identique déjà envoyé.',
  chat_empty: 'Message vide.',
  chat_no_group: 'Tu n’es plus dans un groupe.',
  chat_error: 'Envoi impossible.',
  report_ok: 'Signalement envoyé, merci.',
  report_dup: 'Déjà signalé.',
  report_rate: 'Trop de signalements : réessaie plus tard.',
  report_reason: 'Motif invalide.',
  report_self: 'Tu ne peux pas te signaler toi-même.',
  report_unknown: 'Joueur introuvable.',
  report_error: 'Signalement impossible.',
  gsys_joined: '{name} a rejoint le groupe.',
  gsys_left: '{name} a quitté le groupe.',
  gsys_kicked: '{name} a été retiré du groupe.',
  gsys_leader: '{name} est le nouveau chef.',
  gsys_launch: '{name} lance une partie.',
  reason_insult: 'Insulte',
  reason_spam: 'Spam',
  reason_cheat: 'Triche',
  reason_other: 'Autre',
  leave_group_size: 'Groupe trop grand pour ce mode.',
  play: 'Jouer',
  wipAccount: 'Version de développement — progression enregistrée sur ton compte.',
  variantsTitle: 'Variantes de base',
  variantsIntro: 'Chaque classe a 5 variantes gratuites (Atelier, Désert, Boréal, Obsidienne, Signal), débloquées en jouant cette classe.',
  variantsInTree: 'Les 5 styles se débloquent classe par classe dans l’arbre des classes.',
  noCosmetic: 'Retirer le cosmétique (variantes par classe)',
  variantsShow: 'Voir les variantes',
  variantsLogin: 'Connecte-toi pour débloquer et choisir les variantes.',
  variantChosen: 'Variante {style} choisie pour cette classe.',
  variantLockedMsg: 'Variante encore verrouillée.',
  variantNeedTime: '{have}/{need} min',
  variantNeedKills: '{have}/{need} éliminations',
  variantMastery: 'maîtrise : {min} min, {kills} éliminations',
  settingsSfx: 'Effets de combat',
  settingsUiSounds: 'Sons d’interface',
  settingsMuteHidden: 'Couper le son en arrière-plan',
  settingsA11y: 'Accessibilité',
  settingsColors: 'Couleurs',
  colorsStandard: 'Standard',
  colorsRedGreen: 'Daltonisme rouge-vert',
  colorsBlueYellow: 'Daltonisme bleu-jaune',
  settingsTextSize: 'Taille des textes',
  settingsContrast: 'Contraste élevé',
  settingsVisualCues: 'Repères visuels des sons',
  premium_ended: 'La saison est terminée : le pass premium de la prochaine saison sera proposé à son ouverture.',
  passEnded: 'Saison terminée — pass figé jusqu’à la prochaine saison.',
  translationReview: 'Traduction relue.',
  // Refonte de l’interface (novembre 2026).
  navMain: 'Navigation principale',
  nav_hangar: 'Hangar',
  nav_tree: 'Arbre',
  nav_pass: 'Pass',
  nav_shop: 'Boutique',
  nav_friends: 'Amis',
  walletLabel: '{c} pièces, {g} gemmes',
  hangarModes: 'Ordres de mission',
  hangarYourTank: 'Ton tank',
  hangarSkin: 'Apparence : {name}',
  hangarNoSkin: 'Variantes par classe',
  hangarEvo: 'Première évolution au niveau {n} : {k} familles',
  hangarControls: 'Commandes',
  hangarCallsign: 'Nom de tank',
  hangarStageLabel: 'Aperçu animé : {name}. Clique ou touche pour tirer.',
  hangarFireHint: 'Clique pour tirer',
  hangarTapHint: 'Touche pour tirer',
  modeFormat: 'Format',
  modeDifficulty: 'Difficulté',
  seasonTag: 'Saison {n}',
  seasonGuest: 'Pass de 105 niveaux : crée un compte pour progresser et garder tes récompenses.',
  seasonNext: 'Niveau {n}',
  seasonMissions: 'missions du jour : {n}/{max}',
  groupLeader: 'Chef',
  groupInviteFriends: 'Inviter un ami',
  passTitle: 'Pass de combat',
  passYourLevel: 'Ton niveau',
  passPreview: 'Aperçu du pass',
  passLevelOf: 'Niveau {n} sur {max}',
  passLevels: 'Niveaux : {n}',
  passXpInfo: '100 XP de pass par minute active, plus les missions. 2000 XP par niveau.',
  passGuestInfo: 'Tu peux parcourir toutes les récompenses. Crée un compte pour gagner de l’XP de pass.',
  passPremium: 'Premium',
  passFree: 'Gratuit',
  passPremiumActive: 'Pass premium actif',
  passPremiumActiveInfo: 'Les récompenses premium de chaque niveau atteint te sont données automatiquement.',
  passBalance: 'Ton solde :',
  passTrackLabel: 'Récompenses des 105 niveaux',
  passPrev: 'Niveaux précédents',
  passNext: 'Niveaux suivants',
  passHere: 'Toi',
  passClaimed: 'obtenu',
  passReached: 'atteint',
  passPremiumNeeded: 'pass premium requis',
  passIn: 'niveaux restants : {n}',
  passNewTitle: 'Nouveau palier',
  passNewOne: 'Niveau {n} atteint depuis ta dernière visite.',
  passNewMany: 'Niveaux {a} à {b} atteints depuis ta dernière visite.',
  passEarnTitle: 'Gagner de l’XP de pass',
  missionDone: 'Fait',
  tokenShort_tok_x2: '×2',
  tokenShort_tok_x5: '×5',
  tokenShort_tok_restore: 'Restauration',
  tokenShort_tok_reset: 'Réinitialisation',
  tokenShort_tok_salon: 'Salon',
  tokdesc_tok_x2: '×2 sur toute l’XP de tank pendant 90 s, en arène libre.',
  tokdesc_tok_x5: '×5 sur l’XP des éliminations de tanks pendant 60 s, en arène libre.',
  tokdesc_tok_restore: 'Après une mort, tu retrouves exactement ton tank : niveau, classe, points et modifications.',
  tokdesc_tok_reset: 'Retour à la classe de base en gardant ton XP, pour choisir une autre branche.',
  tokdesc_tok_salon: 'Ouvre un salon privé pendant 4 h, sans récompense.',
  rkind_coins: 'Pièces',
  rkind_gems: 'Gemmes',
  rkind_token: 'Jeton',
  rkind_emblem: 'Emblème',
  rkind_banner: 'Bannière',
  rkind_killfx: 'Effet d’élimination',
  rkind_deathfx: 'Effet de destruction',
  rkind_shotfx: 'Effet de tir',
  rkind_trail: 'Traînée',
  rkind_frame: 'Cadre',
  rkind_collection: 'Collection',
  rkind_item: 'Objet',
  rkdesc_coins: 'Pièces à dépenser dans la boutique de la semaine.',
  rkdesc_gems: 'Gemmes : apparences premium, jetons et pass premium.',
  rkdesc_item: 'Objet de collection de la saison {s}, gardé dans ton inventaire après la fin de la saison.',
  shopSub: 'Prix fixes, contenu montré avant achat.',
  shopSections: 'Rayons de la boutique',
  shopSec_week: 'Offres de la semaine',
  shopSec_gems: 'Gemmes',
  shopSec_tokens: 'Jetons',
  shopSec_convert: 'Conversion',
  shopSec_owned: 'Mes apparences',
  shopSec_history: 'Historique',
  shopWeekNext: 'Nouvelle sélection le {d}',
  shopGuest: 'Tu peux tout regarder. Crée un compte pour acheter et garder tes objets.',
  shopPreview: 'Aperçu',
  shopPreviewOf: 'Aperçu de {name}',
  shopPreviewClasses: 'Voir sur une autre classe',
  shopConfirm: 'Confirmer',
  shopBoughtStamp: 'Acheté',
  shopEquipped: 'Apparence équipée.',
  shopEquippedBadge: 'Équipé',
  shopOwnedCount: 'En stock : {n}',
  shopPaletteInfo: 'La palette s’applique à toutes tes classes tant qu’elle est équipée.',
  shopItemInfo: 'Objet de collection, sans effet sur la partie.',
  shopFairInfo: 'Un cosmétique ne change jamais la hitbox, la précision ni la lisibilité des tirs.',
  convertInfo: 'Conversion à sens unique : les pièces ne redeviennent jamais des gemmes.',
  historyEmpty: 'Aucun achat pour l’instant.',
  hist_shop: 'Achat en boutique',
  hist_tokens: 'Achat de jetons',
  hist_convert: 'Conversion',
  hist_gemspack: 'Pack de gemmes',
  hist_premiumpass: 'Pass premium',
  hist_refund: 'Remboursement',
  hist_tokenuse: 'Jeton utilisé',
  hist_tokenrefund: 'Jeton rendu',
  rOddsTitle: 'Probabilités et règles',
  rOddsTokens: 'Les 5 jetons sont tirés un par un : ×2 40 %, ×5 20 %, restauration 20 %, réinitialisation 15 %, salon 5 %.',
  rRules: 'Singularité déjà possédée : une autre variante non possédée, sinon 5000 pièces. Pass déjà au niveau 105 ou entre deux saisons : chaque niveau gagné devient 500 pièces.',
  shopPackReduced: 'Prix réduit : tu possèdes déjà une partie du contenu.',
  singularityName: 'Singularité',
  collectionTitle: 'Ma collection',
  mailUnavailable: 'L’envoi d’e-mails n’est pas encore disponible : la vérification d’adresse et le mot de passe oublié arrivent bientôt.',
  registeredNoMail: 'Compte créé. La vérification d’adresse par e-mail n’est pas encore disponible : tu pourras la faire plus tard.',
  authSub: 'Joue en invité ou crée un compte pour garder ta progression.',
  authPerksTitle: 'Avec un compte',
  authPerkPass: 'Ton pass de saison progresse et ses récompenses sont gardées.',
  authPerkVariants: 'Les 5 styles de chaque classe se débloquent en jouant.',
  authPerkFriends: 'Amis, groupe et chat de groupe.',
  authPerkShop: 'Boutique, missions et roulette de fin de run.',
  authRegisterHint: 'Mot de passe : 10 caractères minimum. Nom affiché : 3 à 16 caractères.',
  profileSub: 'Ton identité, ton solde et tes jetons.',
  profileWallet: 'Solde',
  profileVerifyWhy: 'Vérifie ton e-mail pour acheter et encaisser la roulette.',
  renameBtn: 'Renommer',
  renameOk: 'Nom affiché modifié.',
  renameFail: 'Nom refusé : 3 à 16 caractères, pas de nom réservé.',
  copy: 'Copier',
  copied: 'Copié',
  copyId: 'Copier l’identifiant',
  friendsSub: 'Ajoute des amis avec leur identifiant public et joue en groupe.',
  friendsGuest: 'Les amis et les groupes demandent un compte.',
  friendsYourId: 'Ton identifiant',
  friendsAddLabel: 'Identifiant public d’un ami',
  settingsSub: 'Réglages gardés sur cet appareil.',
  settingsSoundTitle: 'Son',
  settingsDisplayTitle: 'Affichage',
  settingsControlsTitle: 'Commandes',
  settingsVisualCuesHint: 'Bord de l’écran rougi quand tu es touché.',
  settingsReducedMotionHint: 'Coupe les animations des menus, du fond et de la roulette.',
  settingsQualityHint: 'Plus bas : plus fluide sur les petits appareils.',
  colorSelf: 'Toi',
  colorAlly: 'Allié',
  colorEnemy: 'Adversaire',
  helpSub: 'Commandes, zones de la carte et règles de la partie.',
  helpPcTitle: 'Clavier et souris',
  helpTouchTitle: 'Écran tactile',
  helpZonesTitle: 'Zones de la carte',
  helpFairTitle: 'Jeu loyal',
  helpMove: 'Se déplacer',
  helpAimFire: 'Viser, tirer',
  helpSticks: 'Gauche : bouger · Droite : viser et tirer',
  treePlayable: 'Classes jouables : {n}.',
  treeSearch: 'Chercher une classe',
  treeAll: 'Toutes',
  treeNoResult: 'Aucun résultat.',
  modsSearch: 'Chercher une modification',
  modsSlot: 'Emplacement',
  variantInUse: 'Style utilisé en partie',
  variantUse: 'Utiliser le style {style}',
  deadLevelShort: 'Niveau',
  deadTimeShort: 'Temps',
  deadKillsShort: 'Éliminations',
};
